import React from 'react';
import { KBBlock } from '../../../types';

interface Props {
  block: KBBlock;
  isEditing: boolean;
  onChange: (updates: Partial<KBBlock>) => void;
  onFinish: () => void;
}

const STATUSES: {
  value: string;
  label: string;
  icon: string;
  pill: string;
  btn: string;
}[] = [
  { value: 'not_started', label: 'Not Started', icon: 'ri-circle-line',          pill: 'bg-gray-100 text-gray-600',    btn: 'bg-gray-100 text-gray-600 hover:bg-gray-200'           },
  { value: 'in_progress', label: 'In Progress', icon: 'ri-loader-4-line',         pill: 'bg-blue-100 text-blue-700',    btn: 'bg-blue-100 text-blue-700 hover:bg-blue-200'           },
  { value: 'review',      label: 'In Review',   icon: 'ri-eye-line',              pill: 'bg-amber-100 text-amber-700',  btn: 'bg-amber-100 text-amber-700 hover:bg-amber-200'        },
  { value: 'done',        label: 'Done',        icon: 'ri-checkbox-circle-line',  pill: 'bg-green-100 text-green-700',  btn: 'bg-green-100 text-green-700 hover:bg-green-200'        },
  { value: 'blocked',     label: 'Blocked',     icon: 'ri-close-circle-line',     pill: 'bg-red-100 text-red-700',      btn: 'bg-red-100 text-red-700 hover:bg-red-200'              },
  { value: 'cancelled',   label: 'Cancelled',   icon: 'ri-forbid-line',           pill: 'bg-gray-100 text-gray-400',   btn: 'bg-gray-100 text-gray-400 hover:bg-gray-200'           },
];

const StatusBadgeBlock: React.FC<Props> = ({ block, isEditing, onChange, onFinish }) => {
  const status: string = block.data?.status ?? 'not_started';
  const customLabel: string = block.data?.customLabel ?? '';
  const s = STATUSES.find((x) => x.value === status) ?? STATUSES[0];
  const displayLabel = customLabel || s.label;

  if (isEditing) {
    return (
      <div className="border border-gray-200 rounded-lg p-3 space-y-3">
        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider m-0">Status</p>

        <div className="flex flex-wrap gap-1.5">
          {STATUSES.map((st) => (
            <button
              key={st.value}
              onClick={() => onChange({ data: { ...block.data, status: st.value } })}
              className={`inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-full transition-colors ${st.btn} ${
                status === st.value ? 'ring-2 ring-offset-1 ring-blue-400' : 'opacity-70'
              }`}
            >
              <i className={st.icon} />
              {st.label}
            </button>
          ))}
        </div>

        <input
          type="text"
          value={customLabel}
          placeholder="Custom label (overrides default)"
          onChange={(e) => onChange({ data: { ...block.data, customLabel: e.target.value } })}
          className="w-full text-sm border border-gray-200 rounded px-2 py-1 outline-none focus:border-blue-400"
        />

        <div>
          <button
            onClick={onFinish}
            className="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded transition-colors"
          >
            Done
          </button>
        </div>
      </div>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-full ${s.pill}`}>
      <i className={s.icon} />
      {displayLabel}
    </span>
  );
};

export default StatusBadgeBlock;
